import './About.css';

export default function About() {
    return (
        <section id='about'>

            <h2 className='section-title'>ABOUT</h2>
            
            <div className='about-content'>
                <p>
                    Former forensic consultant, turned self-taught developer. Seven years investigating fraud taught me systematic problem-solving, but I realized I loved the technical parts more than the investigating. So I learned to code: JavaScript, React, Python, SQL. Now I'm looking for junior roles where I can keep building and learning.
                </p>
            </div>
        </section>
    )
}